import React from "react";
import UserList from "../components/UserList";

const Home = () => {
  return (
    <main className=" m-4 p-4">
      <section>
        <UserList />
      </section>
    </main>
  );
};

export default Home;
